import { ResponsiveValue, useTheme } from '@gousto-internal/citrus-react';

/**
 * @example
 * useImageSizes(['100vw', '50vw'])
 */
export function useImageSizes(imageSizes: ResponsiveValue<string>) {
  const { theme } = useTheme();
  const { breakpoints } = theme.tokens;

  if (!Array.isArray(imageSizes)) {
    return imageSizes;
  }

  const defaultValue = imageSizes[0];

  return breakpoints.reduce<string>((sizes, breakpoint, idx) => {
    const sizeForNextBreakpoint = imageSizes[idx + 1];

    return sizeForNextBreakpoint
      ? `(min-width: ${breakpoint}) ${sizeForNextBreakpoint}, ${sizes}`
      : sizes;
  }, defaultValue || '');
}
